/**
 * Firebase singleton
 */

import firebase from "firebase";

const fireApp = firebase.initializeApp({
  apiKey: process.env.FIREBASE_API_KEY,
  authDomain: process.env.FIREBASE_AUTH_DOMAIN,
  databaseURL: process.env.FIREBASE_DATABASE_URL,
  storageBucket: process.env.FIREBASE_STORAGE_BUCKET,
});
const ref = fireApp.database().ref();
const url = process.env.FIREBASE_DATABASE_URL;

export const firebaseRef = ref;
export const firebaseAuth = fireApp.auth();
export const firebaseUrl = url;



/** WEBPACK FOOTER **
 ** ./src/app/config/firebase.js
 **/